'use strict';

export default class OauthAuthorizeController {
  submitted = false;
  $state;

  constructor($window, $state, $http, ToastrSvc, OauthSvc) {
    this.$window = $window;
    this.$state = $state;
    this.$http = $http;
    this.ToastrSvc = ToastrSvc;
    this.OauthSvc = OauthSvc;

    var that = this;

    var stateParams = that.$state.params;
    if(!stateParams.code) {
      return $state.go('oauthlogin', {}, {location: false});
    }

    that.oauthCodeResponse = function() {
      that.OauthSvc.setOk().$promise
        .then(() => {
          if(stateParams.redirect_uri) {
            var url = stateParams.redirect_uri;
            var queryString = Object.keys(stateParams)
              .map(key => key + '=' + stateParams[key])
              .join('&');
            url += '?' + queryString;
            that.$window.location.href = url;
          }
        });
    };
  }

  authorize() {
    this.oauthCodeResponse();
  }
}
